var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("insure-begin-notice", {
        ref: "insureDialog",
        attrs: {
          "insure-type": _vm.insureType,
          "inter-type": _vm.interType,
          "product-id": _vm.productId,
        },
        on: { onNext: _vm.onNext },
      }),
      _c("profession-notice", {
        ref: "noticeDialog",
        attrs: { "insure-type": _vm.insureType, "product-id": _vm.productId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }